import React from "react";
import { Document, Page, Text, View, StyleSheet, Image } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontSize: 11,
    fontFamily: "Helvetica",
    backgroundColor: "#F9F9F9",
    color: "#263238",
  },
  headerContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 25,
  },
  logo: {
    width: 60,
    height: 60,
  },
  title: {
    fontSize: 20,
    textAlign: "right",
    color: "#1B5E20",
    fontWeight: "bold",
    textTransform: "uppercase",
  },
  section: {
    padding: 15,
    border: "1pt solid #B0BEC5",
    borderRadius: 5,
    marginBottom: 20,
    backgroundColor: "#FFFFFF",
  },
  sectionTitle: {
    fontSize: 13,
    marginBottom: 10,
    borderBottom: "1pt solid #90A4AE",
    paddingBottom: 4,
    fontWeight: "bold",
    color: "#37474F",
  },
  field: {
    marginBottom: 8,
    display: "flex",
    flexDirection: "row",
  },
  label: {
    width: "35%",
    fontWeight: "bold",
    color: "#455A64",
  },
  value: {
    width: "65%",
    color: "#263238",
  },
  imagePreview: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 10,
    gap: 8,
  },
  imageBox: {
    width: "32%",
    height: 160,
    objectFit: "contain",
    border: "1pt solid #B0BEC5",
    borderRadius: 4,
  },
  footer: {
    position: "absolute",
    bottom: 30,
    fontSize: 9,
    textAlign: "center",
    width: "100%",
    color: "#90A4AE",
  },
});

const Field = ({ label, value }) => (
  <View style={styles.field}>
    <Text style={styles.label}>{label}:</Text>
    <Text style={styles.value}>{value || "N/A"}</Text>
  </View>
);

const VendorRequestPDF = ({ formData }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.headerContainer}>
        <Image src="/rciLogo.png" style={styles.logo} />
        <Text style={styles.title}>Vendor Payment Request</Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>Vendor Details</Text>
        <Field label="Vendor Name" value={formData.vendorName} />
        <Field label="Vendor Contact" value={formData.vendorContact} />
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>Payment Information</Text>
        <Field label="Order Reference" value={formData.orderReference} />
        <Field label="Job/Employee Form" value={formData.jobOrEmployeeForm} />
        <Field label="Amount" value={formData.amount} />
      </View>

      {formData.vendorImageURLs?.length > 0 && (
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Uploaded Images</Text>
          <View style={styles.imagePreview}>
            {formData.vendorImageURLs.slice(0, 3).map((url, index) => (
              <Image key={index} src={url} style={styles.imageBox} />
            ))}
          </View>
        </View>
      )}

      <Text style={styles.footer}>Confidential — For Internal Use Only</Text>
    </Page>
  </Document>
);

export default VendorRequestPDF;
